import isBefore from 'date-fns/is_before';
import differenceInCalendarDays from 'date-fns/difference_in_calendar_days';
var FORMATS;
(function (FORMATS) {
    FORMATS["ISO_FORMAT"] = "YYYY-MM-DD";
    FORMATS["CURRENT_YEAR_FORMAT_WITHOUT_YEAR"] = "CURRENT_YEAR_FORMAT_WITHOUT_YEAR";
    FORMATS["LOCALIZED_FORMAT"] = "LOCALIZED_FORMAT";
})(FORMATS || (FORMATS = {}));
export var timestampToUTCDate = function (timestamp) {
    var date = new Date(Number(timestamp));
    var day = date.getUTCDate();
    var month = date.getUTCMonth() + 1;
    var year = date.getUTCFullYear();
    return { day: day, month: month, year: year };
};
export var todayTimestampInUTC = function () {
    var today = new Date(Date.now());
    var todayInUTC = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());
    return todayInUTC.toString();
};
var addLeadingZero = function (val) {
    if (val < 10) {
        return "0" + val;
    }
    return val;
};
var capitalizeFirstLetter = function (str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
};
// example: "23 Jan 2018"
export var timestampToString = function (timestamp, intl, pattern) {
    if (!intl || pattern === FORMATS.ISO_FORMAT) {
        return timestampToIsoFormat(timestamp);
    }
    var date = new Date(Number(timestamp));
    var showWeekday = pattern === FORMATS.CURRENT_YEAR_FORMAT_WITHOUT_YEAR;
    var showYear = !showWeekday;
    return intl.formatDate(date, {
        timeZone: 'UTC',
        weekday: showWeekday ? 'short' : undefined,
        month: 'short',
        day: 'numeric',
        year: showYear ? 'numeric' : undefined,
        formatMatcher: 'best fit',
    });
};
// example: "2018-01-23"
export var timestampToIsoFormat = function (timestamp) {
    var date = new Date(Number(timestamp));
    return date.getUTCFullYear() + "-" + addLeadingZero(date.getUTCMonth() + 1) + "-" + date.getUTCDate();
};
export var isPastDate = function (timestamp) {
    return isBefore(timestampToIsoFormat(Number(timestamp)), timestampToIsoFormat(new Date().valueOf()));
};
export var timestampToTaskContext = function (timestamp, intl) {
    var curDate = new Date(Number(todayTimestampInUTC()));
    var givenDate = new Date(Number(timestamp));
    var distance = differenceInCalendarDays(givenDate, curDate);
    var sameYear = givenDate.getUTCFullYear() === curDate.getUTCFullYear();
    if (intl && [-1, 0, 1].indexOf(distance) > -1) {
        return capitalizeFirstLetter(intl.formatRelative(givenDate, {
            units: 'day',
        }));
    }
    return timestampToString(timestamp, intl, sameYear
        ? FORMATS.CURRENT_YEAR_FORMAT_WITHOUT_YEAR
        : FORMATS.LOCALIZED_FORMAT);
};
//# sourceMappingURL=date.js.map